
import { Vue, Component, Watch } from 'vue-property-decorator';

const baseUrl = '0604yqwq';

@Component({
  components: {},
})
export default class ViewHolder extends Vue {
  async created() {}
}
